/* eslint-disable object-shorthand */
import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import {
  useFetchPosProfileDetails,
  useFetchLoggedUser,
} from '@/services/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const restaurant = queryKey[2];
  const userId = queryKey[3];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_kots?user_id=${userId}&restaurant=${restaurant}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchKOT = () => {
  const { url } = useSelector(selectAuth);
  const { data: posDetails } = useFetchPosProfileDetails();
  const { data: userId } = useFetchLoggedUser();

  const restaurant = posDetails?.restaurant;

  return useQuery(['KOT', url, restaurant, userId], fetcher, {
    enabled: Boolean(posDetails && userId),
  });
};
